import { APP_NAME } from "../constant/constant";
import logoSita from "../assets/logo_sita.png";

const NavImage = () => {
  return (
    <>
    <img src={logoSita} alt={`${APP_NAME} logo`} className="nvg_logo" />
    </>
  );
};

export default NavImage;
